import api from '../../utils/api'

export const state = {

}

export const mutations = {

}

export const actions = {
  async handleCreate(_, sector) {
    try {
      return await api.post('/sector', sector)
    } catch (err) {

    }
  },

  async handleGet(_, sectorId) {
    try {
      return await api.get(`/sector/${sectorId}`)
    } catch (err) {

    }
  },


  async handleOpen(_, sectorId) {
    try {
      return await api.put(`/sector/open/${sectorId}`)
    } catch (err) {

    }
  },

  async handleUpdade(_, sector) {
    try {
      return await api.put(`/sector/${sector._id}`, sector)
    } catch (err) {

    }
  },

  async handleDelete(_, body ) {
    try {
      return await api.put(`/sector/delete-hierarchy/${body.sectorId}`, body)
    } catch (err) {

    }
  },

  async handleBindRoles(_, body) {
    try {
      return await api.put(`/sector/bind-roles/${body._id}`, body)
    } catch (err) {

    }
  },

  async handleGetHierarchyByCompanyLegalConsultation({ rootGetters }, companyLegalConsultationId) {
    try {
      const { agents } = rootGetters['legalSearch/summaryMeta'] || {}
      const params = agents && agents.length > 0 ? { agents: agents.join(',') } : {}
      return await api.get(`/sector/hierarchy/companyLegalConsultatio/${companyLegalConsultationId}`, { params })
    } catch (err) {

    }
  },

  async handleGetHierarchyByCompanyLegalConsultationNotLinkedSector({ rootGetters }, companyLegalConsultationId) {
    try {
      const { agents } = rootGetters['legalSearch/summaryMeta'] || {}
      const params = agents && agents.length > 0 ? { agents: agents.join(',') } : {}
      return await api.get(`/role/hierarchy/companyLegalConsultation-not-linked-sector/${companyLegalConsultationId}`, { params })
    } catch (err) {
      // silent
    }
  }

}

export const getters = {

}
